<template>

    <div class="bg-gray-100 dark:bg-gray-800 p-4 sm:p-12 flex-1">
        <div class="max-w-5xl m-auto">


            <!-- callout banner on songs page -->
            <div class="rounded-md bg-blue-100 p-4 mb-4">
                <div class="flex">
                    <div class="flex-shrink-0">
                        <!-- Heroicon name: solid/information-circle -->
                        <svg class="h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
                        </svg>
                    </div>
                    <div class="ml-3 flex-1 md:flex md:justify-between">
                        <p class="text-sm text-blue-700">
                            Welcome to <strong>v0.9-beta</strong> of Pixelsong.io. I am currently working expanding the capabilities
                            for the next release. Please report any bugs you find!
                        </p>
                        <p class="mt-3 text-sm md:mt-0 md:ml-6">
                            <a href="https://github.com/pswulius/pixelsong/wiki" class="whitespace-nowrap font-medium text-blue-700 hover:text-blue-600 hover:underline">Details <span aria-hidden="true">&#10140;   </span></a>
                        </p>
                    </div>
                </div>
            </div>


            <!-- Songs title bar -->
            <div class="flex items-center justify-between py-4">
                <h1 class="text-2xl border-2 border-transparent">Songs</h1>
                <button @click="addNewSong()" class="duration-300 inline-flex items-center px-4 py-2 space-x-2 border border-green-500 text-base font-medium text-green-500 bg-transparent hover:bg-green-100">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                    </svg>
                    <span>New</span>
                </button>
            </div>


            <!-- Song list -->
            <div class="flex flex-col">
                <div class="shadow overflow-hidden sm:rounded-lg">

                    <div class="hidden gap-4 px-4 py-2 lg:grid bg-gray-50 dark:bg-gray-700 border-b border-gray-200 dark:border-gray-800 text-gray-400 grid-cols-5">
                        <div class="col-span-2">Name</div>
                        <div class="">Summary</div>
                        <div class="">Key</div>
                        <div class="text-right">Controls</div>
                    </div>

                    <!-- each row -->
                    <div class="divide-y divide-gray-200 dark:divide-gray-800">


                        <transition-group v-bind:name="listTransitionName">
                        <div v-for="song in songs" :key="song.id" class="grid gap-4 p-4 items-center bg-white dark:bg-gray-900 grid-cols-4 sm:grid-cols-5">

                            <router-link v-bind:to="'/dashboard/'+song.id" class="text-light-blue-500 underline font-bold col-span-2">
                                {{ song.config.name }}
                            </router-link>

                            <div class="hidden sm:block">
                                {{ song.config.instruments.length }} instruments
                            </div>

                            <div>
                                <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">{{ song.config.key }} {{ song.config.keyType }}</span>

                            </div>

                            <div class="flex items-center justify-end">
                                <svg @click="deleteSong(song)" class="w-6 h-6 cursor-pointer text-gray-400 hover:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                                </svg>
                                <div class="block h-4 pl-2 mr-2 border-r"></div>
                                <svg v-if="playingSongId != song.id" @click="playSong(song)" class="w-6 h-6 cursor-pointer text-green-500 hover:text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                                <svg v-if="playingSongId == song.id" @click="pauseSong(song)" class="spinner w-6 h-6 cursor-pointer text-gray-800 hover:text-black dark:text-gray-200 dark:hover:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                            </div>
                        </div>
                        </transition-group>


                    </div>
                </div>

            </div>


            <!-- community reach out -->
            <div class="flex justify-end mt-4">
                <div class="flex items-center space-x-4 text-gray-400">
                    <svg @click="showDiscordWidget=!showDiscordWidget" class="duration-300 h-6 cursor-pointer hover:text-gray-600" viewBox="0 0 532 130"><path fill="currentColor" class="st0" d="M53.2 20.3H20v37.6l22.1 20V41.4H54c7.5 0 11.2 3.7 11.2 9.5v27.9c0 5.8-3.5 9.7-11.2 9.7H20v21.2h33.2c17.8.1 34.5-8.8 34.5-29.4V50.2c0-20.8-16.7-29.9-34.5-29.9zm174.1 60.1V49.6c0-11.1 19.8-13.7 25.8-2.5l18.3-7.5C264.3 23.7 251.1 19 240.2 19c-17.8 0-35.4 10.4-35.4 30.6v30.8c0 20.3 17.6 30.6 35 30.6 11.2 0 24.6-5.6 32-20.1l-19.6-9.1c-4.8 12.4-24.9 9.4-24.9-1.4zm-60.6-26.6c-6.9-1.5-11.5-4-11.8-8.3.4-10.4 16.3-10.7 25.6-.8l14.7-11.4C186 22 175.6 19 164.8 19c-16.3 0-32.1 9.2-32.1 26.8 0 17.1 13 26.2 27.3 28.4 7.3 1 15.4 3.9 15.2 9-.6 9.6-20.2 9.1-29.1-1.8L132 94.8c8.3 10.7 19.6 16.2 30.2 16.2 16.3 0 34.4-9.5 35.1-26.8 1-22-14.8-27.5-30.6-30.4zm-66.9 55.9h22.4V20.3H99.8v89.4zm377.7-89.4h-33.2v37.6l22.1 20V41.4h11.8c7.5 0 11.2 3.7 11.2 9.5v27.9c0 5.8-3.5 9.7-11.2 9.7h-34v21.2h33.2c17.8.1 34.5-8.8 34.5-29.4V50.2c.1-20.8-16.6-29.9-34.4-29.9zM314.6 19c-18.4 0-36.7 10.1-36.7 30.7v30.6c0 20.5 18.4 30.7 36.9 30.7 18.4 0 36.7-10.2 36.7-30.7V49.7c0-20.5-18.5-30.7-36.9-30.7zM329 80.3c0 6.4-7.2 9.7-14.3 9.7-7.2 0-14.4-3.2-14.4-9.7V49.7c0-6.6 7-10.1 14-10.1 7.3 0 14.7 3.2 14.7 10.1v30.6zm102.8-30.6c-.5-21-14.7-29.4-33-29.4h-35.5v89.5H386V81.3h4l20.6 28.4h28L414.4 79c10.8-3.4 17.4-12.7 17.4-29.3zm-32.6 12.1H386V41.4h13.2c14.2 0 14.2 20.4 0 20.4z"/></svg>
                    <a target="_blank" href="https://github.com/pswulius/pixelsong/issues"><svg class="duration-300 h-4 hover:text-gray-600" viewBox="0 0 512 139" version="1.1" preserveAspectRatio="xMidYMid"><g><path d="M98.6961598,59.3124474 L55.6354962,59.3124474 C54.5247282,59.3124474 53.623096,60.2151464 53.623096,61.3259144 L53.623096,82.3792882 C53.623096,83.4900562 54.5247282,84.3938224 55.6354962,84.3938224 L72.4335936,84.3938224 L72.4335936,110.550753 C72.4335936,110.550753 68.6616775,111.836513 58.2336902,111.836513 C45.930948,111.836513 28.744455,107.341157 28.744455,69.5494382 C28.744455,31.7491835 46.6405165,26.7758029 63.4418154,26.7758029 C77.9852995,26.7758029 84.2508415,29.336651 88.2372288,30.5701264 C89.4899103,30.9542537 90.648694,29.706907 90.648694,28.5950722 L95.4524188,8.25340062 C95.4524188,7.73376182 95.2763603,7.10742103 94.6830971,6.68167999 C93.0644278,5.52716422 83.1870225,-1.42108547e-14 58.2336902,-1.42108547e-14 C29.487101,-1.42108547e-14 0,12.2301846 0,71.022993 C0,129.817935 33.7605165,138.579238 62.2094068,138.579238 C85.7649432,138.579238 100.054476,128.51297 100.054476,128.51297 C100.643471,128.187529 100.707493,127.364856 100.707493,126.987131 L100.707493,61.3259144 C100.707493,60.2151464 99.8069278,59.3124474 98.6961598,59.3124474 Z M320.495497,7.35923776 C320.495497,6.23886664 319.607737,5.33510059 318.496969,5.33510059 L294.251072,5.33510059 C293.143503,5.33510059 292.24294,6.23886664 292.24294,7.35923776 C292.24294,7.36457288 292.24934,54.215292 292.24934,54.215292 L254.456556,54.215292 L254.456556,7.35923776 C254.456556,6.23886664 253.564526,5.33510059 252.455893,5.33510059 L228.211061,5.33510059 C227.107764,5.33510059 226.208265,6.23886664 226.208265,7.35923776 L226.208265,134.231131 C226.208265,135.350435 227.107764,136.26167 228.211061,136.26167 L252.455893,136.26167 C253.564526,136.26167 254.456556,135.350435 254.456556,134.231131 L254.456556,79.9635547 L292.24934,79.9635547 C292.24934,79.9635547 292.183187,134.226863 292.183187,134.231131 C292.183187,135.350435 293.082684,136.26167 294.191317,136.26167 L318.494835,136.26167 C319.605604,136.26167 320.493364,135.350435 320.495497,134.231131 L320.495497,7.35923776 Z M144.371023,24.3216565 C144.371023,15.591298 137.371371,8.53616094 128.735977,8.53616094 C120.10912,8.53616094 113.104133,15.591298 113.104133,24.3216565 C113.104133,33.042412 120.10912,40.1167554 128.735977,40.1167554 C137.371371,40.1167554 144.371023,33.042412 144.371023,24.3216565 Z M142.447186,107.534288 L142.447186,48.9698214 C142.447186,47.8579864 141.549822,46.9488852 140.441188,46.9488852 L116.272115,46.9488852 C115.163481,46.9488852 114.171153,48.0927309 114.171153,49.2045657 L114.171153,133.109693 C114.171153,135.575576 115.707662,136.308619 117.696587,136.308619 L139.472334,136.308619 C141.861392,136.308619 142.447186,135.135964 142.447186,133.070213 L142.447186,107.534288 Z M413.161929,46.9488852 L389.10169,46.9488852 C387.998389,46.9488852 387.099963,47.8579864 387.099963,48.9772906 L387.099963,111.186697 C387.099963,111.186697 380.988068,115.658579 372.312128,115.658579 C363.637256,115.658579 361.334627,111.722341 361.334627,103.227794 L361.334627,48.9772906 C361.334627,47.8579864 360.43833,46.9488852 359.333962,46.9488852 L334.915206,46.9488852 C333.812978,46.9488852 332.910277,47.8579864 332.910277,48.9772906 L332.910277,107.335822 C332.910277,132.566579 346.972537,138.739291 366.317608,138.739291 C382.1874,138.739291 394.983106,129.971587 394.983106,129.971587 C394.983106,129.971587 395.592374,134.591784 395.867664,135.140232 C396.144024,135.686546 396.862125,136.238196 397.63785,136.238196 L413.172597,136.169906 C414.274829,136.169906 415.177528,135.258671 415.177528,134.144702 L415.170059,48.9772906 C415.170059,47.8579864 414.27056,46.9488852 413.161929,46.9488852 Z M468.596822,115.706595 C460.251661,115.452644 454.591116,111.665789 454.591116,111.665789 L454.591116,71.4882139 C454.591116,71.4882139 460.175898,68.0652134 467.027235,67.4527437 C475.691441,66.6770202 484.039804,69.2944203 484.039804,89.9626002 C484.039804,111.757553 480.272156,116.058711 468.596822,115.706595 Z M478.086899,44.2237159 C464.421573,44.2237159 455.12676,50.3206689 455.12676,50.3206689 L455.12676,7.35923776 C455.12676,6.23886664 454.231532,5.33510059 453.126097,5.33510059 L428.811913,5.33510059 C427.706479,5.33510059 426.808048,6.23886664 426.808048,7.35923776 L426.808048,134.231131 C426.808048,135.350435 427.706479,136.26167 428.815112,136.26167 L445.684702,136.26167 C446.444417,136.26167 447.019542,135.870074 447.444215,135.18398 C447.863555,134.502154 448.468557,129.334575 448.468557,129.334575 C448.468557,129.334575 458.41105,138.756363 477.232216,138.756363 C499.328069,138.756363 512,127.548384 512,88.4410293 C512,49.3336752 491.761829,44.2237159 478.086899,44.2237159 Z M212.229235,46.731213 L194.041876,46.731213 C194.041876,46.731213 194.014134,22.7093892 194.014134,22.704054 C194.014134,21.7949529 193.545712,21.3404024 192.494697,21.3404024 L167.709954,21.3404024 C166.746435,21.3404024 166.22893,21.7640094 166.22893,22.6901829 L166.22893,47.5197408 C166.22893,47.5197408 153.808816,50.5180675 152.969071,50.760281 C152.132527,51.0024947 151.516857,51.77395 151.516857,52.6937215 L151.516857,68.2967567 C151.516857,69.4192619 152.413154,70.3240948 153.521788,70.3240948 L166.22893,70.3240948 L166.22893,107.859729 C166.22893,135.739897 185.785275,138.478938 198.98218,138.478938 C205.011911,138.478938 212.224966,136.542296 213.41576,136.102684 C214.135999,135.838063 214.554271,135.092216 214.554271,134.283415 L214.574544,117.119329 C214.574544,116.000025 213.629165,115.094125 212.564279,115.094125 C211.504728,115.094125 208.79343,115.525201 206.002106,115.525201 C197.069013,115.525201 194.041876,111.371292 194.041876,105.994577 C194.041876,100.622131 194.04081,70.3240948 194.04081,70.3240948 L212.229235,70.3240948 C213.337868,70.3240948 214.235233,69.4192619 214.235233,68.2967567 L214.235233,48.7532162 C214.235233,47.633912 213.337868,46.731213 212.229235,46.731213 Z" fill="currentColor"></path></g></svg></a>
                </div>
            </div>


            <!-- discord popup -->
            <div v-show="showDiscordWidget" class="fixed z-10 inset-0 overflow-y-auto">
                <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <!--
                      Background overlay, show/hide based on modal state.
                    -->
                    <transition
                        name="discord-transition-1"
                        enter-active-class="ease-out duration-300"
                        enter-from-class="opacity-0"
                        enter-to-class="opacity-100"
                        leave-active-class="ease-in duration-200"
                        leave-from-class="opacity-100"
                        leave-to-class="opacity-0">
                        <div v-show="showDiscordWidget" class="fixed inset-0 transition-opacity" aria-hidden="true">
                            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                        </div>
                    </transition>

                    <!-- This element is to trick the browser into centering the modal contents. -->
                    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                    <!--
                      Modal panel, show/hide based on modal state.
                    -->
                    <transition
                        name="discord-transition-2"
                        enter-active-class="ease-out duration-300"
                        enter-from-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                        leave-active-class="ease-in duration-200"
                        leave-from-class="opacity-100 translate-y-0 sm:scale-100"
                        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <div v-show="showDiscordWidget" class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                        <div>
                            <div class="text-center">
                                <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                                    Join our discord server
                                </h3>
                                <div class="mt-2 mb-4">
                                    <p class="text-sm text-gray-500">
                                        Here you can discuss Pixelsong with other users and the Pixelsong developer.
                                    </p>
                                </div>
                                <iframe src="https://discord.com/widget?id=815455909894815774&theme=dark" width="100%" height="300" allowtransparency="true" frameborder="0" sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"></iframe>
                            </div>
                        </div>
                        <div class="mt-5 sm:mt-6">
                            <button type="button" @click="showDiscordWidget=false" class="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-light-blue-500 text-base font-medium text-white hover:bg-light-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm">
                                Go back to dashboard
                            </button>
                        </div>
                    </div>
                    </transition>
                </div>
            </div>

        </div>
    </div>

</template>


<script>
import * as Pixelsong from "@/player/index.js";
import * as Tone from 'tone';

export default {
    name: "Songs.vue",
    inject: ['player', 'emitter'],
    components: {},
    data() {
        return {
            websiteId: '',
            myId: Math.floor(Math.random() * 1000000),
            psd2: new Pixelsong.PsData2(),
            playingSongId: '',
            deletingSongId: null,
            showDiscordWidget: false,
            listTransitionName : 'None', // so we can skip the animation when the list is initially populated
        }
    },

    computed: {
        currentUser() {
            return this.$store.state.user;
        },

        songs() {
            return this.$store.state.songs;
        }
    },

    mounted() {
        if (!this.currentUser) {
            this.$store.dispatch('relogin')
                .then(() => {this.initialize();})
                .catch(err => {this.$router.push('/login');});
        } else {this.initialize();}
    },

    unmounted() {
        this.cleanup();
    },

    methods: {
        initialize() {
            this.websiteId = this.$store.state.account.websiteId;
            this.load();
            window.addEventListener('beforeunload', this.onWindowUnload);
            this.connectListeners();
        },

        // ---------------------
        // Loading from database
        // ---------------------
        load() {
            this.$store.dispatch('getSongs')
            .then(() => {
                this.listTransitionName = "songs";
            });
        },

        playSong(s) {
            if (this.playingSongId) {
                this.player.cleanup();
                this.playingSongId = null;
            }

            this.startPlayer(s.config);
            this.playingSongId = s.id;
        },

        pauseSong(s) {
            this.player.cleanup();
            this.playingSongId = null;
            console.log('pausing song',s);
        },

        startPlayer(config) {
            Tone.start();
            this.player.init('player-1', this.websiteId, this.emitter, this.psd2, this.isMobile());
            this.player.loadConfig(config);
            this.player.connect();
        },

        addNewSong() {
            const newSong = {
                websiteId: this.websiteId,
                name: 'newsong',
                config: {
                    version: '1.0',
                    name: 'My New Song',
                    key: 'F',
                    keyType: 'Major',
                    volumne: -10,
                    instruments: []
                }
            }

            this.$store.dispatch('addSong', newSong)
                .then(() => {
                    // send user to edit the new song
                    this.$router.push('/dashboard/' + newSong.id);
                });

        },

        deleteSong(s) {
            this.deletingSongId = s.id;
            if (confirm('Are you sure you want to delete this song?')) {
                // delete song here
                this.$store.dispatch('deleteSong', s);
            }
        },

        // ---------
        // Listeners
        // ---------
        connectListeners() {
        },

        disconnectListeners() {
        },


        // --------
        // Cleanup
        // --------
        onWindowUnload(e) {
            console.debug("Window closed, cleaning up pixelsong components. " + e)
            this.cleanup();
        },

        cleanup() {
            console.info("Pixelsong cleaning up.")
            this.disconnectListeners();
            this.player.cleanup();
        },

        isMobile() {
            var check = false;
            (function (a) {
                if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4)))
                    check = true;
            })(navigator.userAgent || navigator.vendor || window.opera);
            return check;
        }

    }
}
</script>


<style>
.spinner {
    animation-name: spin;
    animation-duration: 4000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

@keyframes spin {
    from {transform:rotate(0deg);}
    to {transform:rotate(360deg);}
}


/* Song list transitions */
.songs-item {
    display: inline-block;
    margin-right: 10px;
}
.songs-enter-active,
.songs-leave-active {
    transition: all 1s ease;
}
.songs-enter-from,
.songs-leave-to {
    opacity: 0;
}


</style>
